<template>
    <v-card :height="kioskAnalyticsDimension.userSessionheight" flat>
        <v-row class="fill-height" no-gutters>
            <v-col cols="5" align-self="center">
                <annual-bar-chart class="mt-5" :userSessionList="userSessionList"
                    v-if="selectedDuration === '2025'"></annual-bar-chart>
                <this-week-bar-chart class="mt-5" :userSessionList="userSessionList"
                    v-if="selectedDuration === 'This Week'"></this-week-bar-chart>
                <today-bar-chart class="mt-5" :userSessionList="userSessionList"
                    v-if="selectedDuration === 'Today'"></today-bar-chart>
                <today-bar-chart class="mt-5" :userSessionList="userSessionList"
                    v-if="selectedDuration === 'Yesterday'"></today-bar-chart>
                <today-bar-chart class="mt-5" :userSessionList="userSessionList"
                    v-if="selectedDuration === 'Select Date'"></today-bar-chart>
                <this-week-bar-chart class="mt-5" :userSessionList="userSessionList"
                    v-if="selectedDuration === 'Select Week'"></this-week-bar-chart>
                <FiscalYearBarChart class="mt-5" :userSessionList="userSessionList"
                    v-if="selectedDuration === 'Fiscal Year'"></FiscalYearBarChart>
            </v-col>
            <v-col cols="5" align="center" align-self="center">
                <pie-chart></pie-chart>
            </v-col>
            <v-col cols="2" align="center" align-self="center">
                <language-bar-chart></language-bar-chart>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import AnnualBarChart from '../../../graphs/annualBarChart.vue';
import ThisWeekBarChart from '../../../graphs/thisWeekBarChart.vue';
import TodayBarChart from '../../../graphs/todayBarChart.vue';
import { mapGetters } from 'vuex'
import PieChart from '../../../graphs/pieChart.vue';
import LanguageBarChart from '../../../graphs/languageBarChart.vue';
import FiscalYearBarChart from '../../../graphs/fiscalYearBarChart.vue';

export default {
    name: 'reports',
    props: {
        userSessionList: Array,
        selectedDuration: String
    },
    computed: {
        ...mapGetters(['kioskAnalyticsDimension', 'selectedSingleDate', 'weekDatePicker', 'selectedWeekDate', 'singleDatePicker', 'displayDate', 'closeWithoutSelection'])
    },
    components: {
        AnnualBarChart,
        ThisWeekBarChart,
        TodayBarChart,
        PieChart,
        LanguageBarChart,
        FiscalYearBarChart
    },
    data() {
        return {
            //
        }
    },
    watch: {
        closeWithoutSelection(newVal) {
            if (newVal === 1) {
                //
                this.selectedDuration = 'Today'

            }
        },
        selectedDuration(newVal) {
            console.log('Coming in here: ', newVal)
            if (newVal === 'Today') {
                this.$store.commit('setSelectedSingleDate', null)
                this.$store.commit('setSelectedWeekDate', null)
                this.$store.dispatch('getKioskAnalytics', {
                    type: 'Today',
                    start: null,
                    end: null
                })
                this.$store.commit('setcloseWithoutSelection', 0)
            } else if (newVal === 'This Week') {
                this.$store.commit('setSelectedSingleDate', null)
                this.$store.commit('setSelectedWeekDate', null)
                this.$store.dispatch('getKioskAnalytics', {
                    type: 'This Week',
                    start: null,
                    end: null
                })
            } else if (newVal === '2025') {
                this.$store.commit('setSelectedSingleDate', null)
                this.$store.commit('setSelectedWeekDate', null)
                this.$store.dispatch('getKioskAnalytics', {
                    type: '2025',
                    start: null,
                    end: null
                })
            } else if (newVal === 'Yesterday') {
                this.$store.commit('setSelectedSingleDate', null)
                this.$store.commit('setSelectedWeekDate', null)
                this.$store.dispatch('getKioskAnalytics', {
                    type: 'Yesterday',
                    start: null,
                    end: null
                })
            } else if (newVal === 'Select Date') {
                this.$store.commit('setSelectedWeekDate', null)
            }
            else {
                //this.$store.commit('setSelectedSingleDate', null)
            }
        }
    }

}
</script>
<style>
.cardBorderStyle {
    border-right: solid 1px #111111 !important;
    border-radius: 0px !important;
}
</style>
